export const POIs = [
    'Cube_village',
    'Cube_office',
    'Cube_residence',
    'Cube_shop',
    'Cube_cottage',
    'Cube_appartments_1',
    'Cube_appartments_2',
    'Cube_solar_panels',
    'Cube_windcathers',
    'Cube_park',
]